export const ADD_TO_USER = "ADD_TO_USER";
export const DELETE_USER = "DELETE_USER";
export const DELETE_ALL_FROM_CART = "DELETE_ALL_FROM_CART";
export const DELETE_ALL_FROM_WISHLIST = "DELETE_ALL_FROM_WISHLIST";

export const addToUser = (item, addToast) => {
  return dispatch => {
    if (addToast) {
      addToast("Successfully logged in!", {
        appearance: "success",
        autoDismiss: true
      });
    }

    dispatch({ type: ADD_TO_USER, payload: item });
  };
};

export const deleteUser = (addToast) => {
  return dispatch => {
    // Clear token from localStorage
    localStorage.removeItem("token");
    
    // Clear cart and wishlist data when logging out
    dispatch({ type: DELETE_ALL_FROM_CART });
    dispatch({ type: DELETE_ALL_FROM_WISHLIST });
    
    // if (addToast) {
    //   addToast("Successfully logged out!", {
    //     appearance: "info",
    //     autoDismiss: true
    //   });
    // }

    dispatch({ type: DELETE_USER });
  };
};
